import { motion } from "framer-motion";
import { SpecimenLabel } from "./SpecimenLabel";

interface MechanismNodeProps {
  step: number;
  title: string;
  description: string;
  className?: string;
  delay?: number;
}

export const MechanismNode = ({ 
  step, 
  title, 
  description, 
  className = "",
  delay = 0 
}: MechanismNodeProps) => {
  return (
    <motion.div
      className={`flex flex-col items-center text-center ${className}`}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ delay, duration: 0.5 }}
    >
      {/* Node circle */}
      <motion.div
        className="w-16 h-16 rounded-full border border-brand-600/40 flex items-center justify-center mb-4 relative"
        initial={{ scale: 0.8 }}
        whileInView={{ scale: 1 }}
        viewport={{ once: true }}
        transition={{ delay: delay + 0.1, duration: 0.3, type: "spring" }}
      >
        <span className="font-editorial text-2xl text-foreground">{step}</span>
        
        {/* Ink splash effect */}
        <motion.div
          className="absolute inset-0 rounded-full bg-brand-500/10"
          initial={{ scale: 0, opacity: 0 }}
          whileInView={{ scale: 1.2, opacity: 0 }}
          viewport={{ once: true }}
          transition={{ delay: delay + 0.2, duration: 0.6 }}
        />
      </motion.div>

      {/* Title */}
      <SpecimenLabel text={title} className="mb-2" delay={delay + 0.2} />

      {/* Description */}
      <motion.p
        className="text-muted-foreground text-sm max-w-[200px]"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: delay + 0.3, duration: 0.4 }}
      >
        {description}
      </motion.p>
    </motion.div>
  );
};

interface MechanismConnectorProps {
  className?: string;
  delay?: number;
}

export const MechanismConnector = ({ className = "", delay = 0 }: MechanismConnectorProps) => {
  return (
    <motion.div
      className={`hidden md:flex items-center justify-center flex-1 px-4 ${className}`}
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ delay, duration: 0.3 }}
    >
      <motion.div
        className="h-px w-full bg-brand-600/30"
        initial={{ scaleX: 0 }}
        whileInView={{ scaleX: 1 }}
        viewport={{ once: true }}
        transition={{ delay: delay + 0.1, duration: 0.5 }}
        style={{ transformOrigin: "left" }}
      />
    </motion.div>
  );
};
